import React from "react";
import type { DetailData } from "../../../../../contexts/chat-log/chat-log-context";
import { isDirectNavigationLink } from "../../../../../libs/fns";
import AssetCard from "./asset-card";

export default function Image({
  file_path,
  file_name,
  thumbnail,
  link,
  asset_title,
  text,
  fullWidth,
}: Pick<DetailData, "file_path" | "file_name" | "thumbnail" | "link" | "asset_title" | "text"> & { fullWidth?: boolean }) {
  // 拡大ポップアップの表示状態
  const [lightboxOpen, setLightboxOpen] = React.useState(false);

  // ESCキーでポップアップを閉じる
  React.useEffect(() => {
    if (!lightboxOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") setLightboxOpen(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightboxOpen]);

  const handleClick = () => {
    if (link && isDirectNavigationLink(link)) {
      window.location.href = link;
    } else if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    } else {
      // リンクがない場合はポップアップで拡大表示
      setLightboxOpen(true);
    }
  };

  return (
    <>
      {/* 拡大ポップアップ */}
      {lightboxOpen && (
        <div
          onClick={() => setLightboxOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* 拡大画像 + 閉じるボタン */}
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ position: "relative", display: "inline-block" }}
          >
            <button
              onClick={() => setLightboxOpen(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                height: "28px",
                padding: "0 12px",
                borderRadius: "14px",
                background: "rgba(0,0,0,0.55)",
                border: "1.5px solid rgba(255,255,255,0.7)",
                color: "#fff",
                fontSize: "12px",
                fontWeight: "bold",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10,
                backdropFilter: "blur(4px)",
                whiteSpace: "nowrap",
              }}
              aria-label="閉じる"
            >
              閉じる
            </button>
            <img
              src={file_path}
              alt={file_name}
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                objectFit: "contain",
                borderRadius: "12px",
                boxShadow: "0 8px 40px rgba(0,0,0,0.5)",
                display: "block",
              }}
            />
          </div>
        </div>
      )}
      <AssetCard
        thumbnailUrl={thumbnail || file_path}
        alt={file_name}
        title={asset_title || undefined}
        description={text || undefined}
        onButtonClick={handleClick}
        fullWidth={fullWidth}
      />
    </>
  );
}
